export default __webpack_public_path__ + "static/media/logo.d190168a.svg";